"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const intl_1 = require("@kyruus/intl");
const banner_1 = __importDefault(require("@kyruus/banner"));
const provider_components_1 = require("@kyruus/provider-components");
const expandable_card_container_1 = __importDefault(require("../ExpandableCardContainer/expandable-card-container"));
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../lib/messages"));
const utils_1 = require("../../lib/utils");
const with_error_boundary_1 = require("../ErrorFallback/with-error-boundary");
const ProviderInsuranceAccepted = ({ intl, provider, config, track }) => {
    const { insurance_accepted } = (0, utils_1.pruneIgnoredValues)(provider, 'insurance_accepted', config);
    const sortedInsuranceNameObjects = (0, react_1.useMemo)(() => (0, utils_1.sortByName)(insurance_accepted.map((name) => ({ name }))), [insurance_accepted]);
    return (react_1.default.createElement(expandable_card_container_1.default, { id: "profile-insurance-section", track: track },
        react_1.default.createElement(styles_1.InsurancesAcceptedContainer, null,
            react_1.default.createElement(provider_components_1.ProviderInfoListBox, { id: `${provider.id}-insurance-accepted`, cssClasses: "provider-insurances", title: intl.formatMessage(messages_1.default.insuranceComponentTitle), itemType: intl.formatMessage(messages_1.default.insuranceComponentSearchAriaLabelItemType), searchInputTitle: react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.insuranceComponentSearchTitle)), items: sortedInsuranceNameObjects, showClearSearchIcon: true, numColumns: 2, log: track, message: react_1.default.createElement(styles_1.DisclaimerContainer, null,
                    react_1.default.createElement(banner_1.default, { icon: "i", type: "info" },
                        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.insuranceDisclaimerMessage)))), isV9Profile: true, showSearch: true }))));
};
exports.default = (0, with_error_boundary_1.withErrorBoundary)((0, intl_1.injectIntl)(ProviderInsuranceAccepted));
//# sourceMappingURL=provider-insurance-accepted.js.map